const maintenance = {
    'plate': 'Plate No.',
    'total_mileage': 'ODO (km)',
    'last_regular_maintenance': 'LRM (km)',
    'maintenance_countdown_distance': 'SCD (km)',
    'last_regular_maintenance_date': 'LRM Date',
};

export default maintenance;
